import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';

export const docsAssistantPlugin = createPlugin({
  id: 'docs-assistant',
  routes: {
    root: rootRouteRef,
  },
});

/**
 * Ask: the portal's one place to put a question (DX-357). The plugin keeps its
 * id, because `docs-assistant` is also the backend it talks to — the Docs
 * Assistant is Ask's engine, not a page of its own any more.
 */
export const AskPage = docsAssistantPlugin.provide(
  createRoutableExtension({
    name: 'AskPage',
    component: () => import('./components/AskPage').then(m => m.AskPage),
    mountPoint: rootRouteRef,
  }),
);
